<template>
  <div class="card flex flex-col h-full my-6">
    <HotelPackageCardHeader
      class="card-header"
      :package="package"
      :static-images="useStaticImages"
      :allow-gallery="false"
      :nested-slider="nestedSlider"
      :current-charter-tag="currentCharterTag"
    />
    <div
      class="card-body white-bg grow flex flex-col py-4 cursor-pointer"
      @click="navigateTo(packageLink)"
    >
      <DestinationHotelPackageCardHotelInfo
        class="grow flex flex-col"
        :package="package"
        :show-favourite="true"
      />
      <div class="mt-auto">
        <div class="flex justify-between items-end">
          <div class="price-container flex flex-col items-center">
            <div
              v-if="discountedPrice"
              class="price-above strikethrough"
            >
              {{ $n(package.regular_pricepp) }}
            </div>
            <div class="font-bold">
              <span>
                fr.
              </span>
              <span
                class="price pl-2"
                :class="discountedPrice ? 'price__discounted' : ''"
              >{{ $n(package.pricepp) }}</span>
            </div>
          </div>
          <NuxtLink
            class="book-btn-content btn btn-orange btn-rounded py-2 font-bold"
            :to="packageLink"
          >
            {{ $t('readMore') }}
          </NuxtLink>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default defineNuxtComponent({
  setup () {
    const { urls: localeURLs } = useLocale()

    return {
      localeURLs,
    }
  },

  props: {
    // package
    hotel: {
      type: Object,
      required: true,
    },

    nestedSlider: {
      type: Boolean,
      default: false,
    },

    useStaticImages: {
      type: Boolean,
      default: false,
    },

    currentCharterTag: {
      type: Object,
      default: null,
    },
  },

  computed: {
    package () {
      return this.hotel
    },

    discountedPrice () {
      return this.package.pricepp < this.package.regular_pricepp
    },

    packageLink () {
      if (this.package.url.startsWith(this.localeURLs.BASE_URL) || !this.package.url.startsWith('http')) {
        const hotelUrl = this.package.url.replace(this.localeURLs.BASE_URL, '')
        const hotelUrlWithoutParams = hotelUrl.split('?')?.[0]

        return hotelUrlWithoutParams || hotelUrl
      }
      return this.package.url
    },
  },
})
</script>

<style lang="scss" scoped>
:deep(.responsive-hotel-image){
  border-top-right-radius: 12px;
  border-top-left-radius: 12px;
}
.btn {
  text-transform: unset !important;
}
.card {
  max-width: 400px;
  margin: auto;
  filter: drop-shadow(0px 5px 5px rgba(0, 0, 0, 0.25));
}

.card-header {
  position: relative;
}

.card-body {
  padding: 1.3rem;
  min-height: 325px !important;
  max-height:325px !important;
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;
}
.price-above {
  font-size: 1rem;
}
.price-above .strikethrough {
    &:before {
      border-top: 1px solid;
    }
  }
.price {
  font-family: theme('fontFamily.secondary');
  font-size: 1.6rem;

  &__discounted{
    color: theme('colors.discounted');
  }
}

.book-btn-content {
  white-space: nowrap;
  padding-inline: 1.8rem;
  font-size: 1rem;

    @media (max-width: 992px) {
      font-size: .9rem;
    }
    @media (max-width: 768px) {
      padding-left: 1rem;
      padding-right: 1rem;
    }
}
</style>
